/* Curate the existing variant cards after the variant app finishes a batch. */
class LDCollectionColors extends HTMLElement {
  #onVariantsDisplayed = () => this.#arrange();
  #priority = [];

  connectedCallback() {
    if (this.dataset.enabled !== 'true') return;
    try {
      const priority = JSON.parse(this.dataset.priority || '[]');
      if (!Array.isArray(priority)) return;
      this.#priority = priority.filter(key => typeof key === 'string');
    } catch {
      return;
    }
    if (!this.#priority.length) return;
    window.addEventListener('b4bVariantsDisplayed', this.#onVariantsDisplayed);
    this.#arrange();
  }

  disconnectedCallback() {
    window.removeEventListener('b4bVariantsDisplayed', this.#onVariantsDisplayed);
  }

  #arrange() {
    const grid = document.querySelector('main .js-grid[data-b4b-collection-handle]');
    if (!grid || grid.dataset.b4bCollectionHandle !== this.dataset.collection) return;

    // A shopper's explicit price, best-selling, or alphabetical sort takes priority.
    const params = new URL(window.location.href).searchParams;
    const urlSort = params.get('sort_by') || params.get('sort');
    const selectedSort = document.querySelector('main [data-sort-link][aria-current="true"]')?.dataset.value;
    if ((urlSort && urlSort !== 'manual') || (selectedSort && selectedSort !== 'manual')) return;

    const cards = Array.from(grid.children).filter(card => card.matches('.variable-products[data-handle][data-b4b-color]'));
    const preferred = [];
    for (const key of this.#priority) {
      const card = cards.find(item => `${item.dataset.handle}|${item.dataset.b4bColor}`.toLowerCase() === key);
      if (card && !preferred.includes(card)) preferred.push(card);
    }
    if (!preferred.length || preferred.every((card, index) => cards[index] === card)) return;

    // Move actual cards so keyboard order follows the visual order. All remaining
    // colors, their links, prices, images, and the app's pagination stay intact.
    for (let index = preferred.length - 1; index >= 0; index -= 1) {
      grid.insertBefore(preferred[index], grid.firstElementChild);
    }
  }
}

if (!customElements.get('ld-collection-colors')) {
  customElements.define('ld-collection-colors', LDCollectionColors);
}
